// Keep native classes instead of the legacy-transpiled distribution bundle.
import GLightbox from "glightbox/src/js/glightbox.js";

const lightbox = GLightbox();
